require([
	"jquery",
	"underscore",
	"bootstrap",
	"react",
	"jsx!components/pebblego-login-portal",
	"shared/array-polyfill",
	"shared/pwa-polyfill"
], function ($, _, Bootstrap, React, AppComponent) 
{
	var app = React.createElement(AppComponent);
	React.render(app, document.getElementById('login-wrapper'));
}, function (error)
{
	console.log(error);
});
define("init-pebblego-login-portal.js", function(){});

